import React, { useEffect } from "react";
import Header from "../components/admin/header";
// import Footer from "../components/admin/Footer";
import { Outlet } from "react-router-dom";

const PublicLayout = () => {
    useEffect(() => {
    document.body.style.fontFamily = "Inter, sans-serif";
    document.body.style.backgroundColor = "var(--al-bg-body)";
    document.body.style.overflow = "hidden"; // ✅ scroll enable

    return () => {
      document.body.style.overflow = ""; // reset when leaving page
    };
  }, []);
  return (
    <>
      <Header />
      <main>
        <Outlet /> {/* This is where the nested page content will render */}
      </main>
      {/* <Footer /> */}
    </>
  );
};

export default PublicLayout;